/**
 * @fileoverview Stable `agent_type` analytics identifiers for interaction sites.
 * Must stay identical to backend CustomerAgentDefinition#agent_type_label. NOT
 * user-facing (see interactionSiteLabelsGetter); keep stable for analytics. The
 * exhaustive switch makes a new interaction site a compile-time error here.
 * @owner @Appboy/intelligence
 */

import { exhaustiveCheck } from "@lib/exhaustiveCheck";

import type { InteractionSite } from "./types";
import { INTERACTION_SITES } from "./types";

export const interactionSiteAnalyticsLabel = (site: InteractionSite): string => {
  switch (site) {
    case INTERACTION_SITES.CANVAS:
      return "canvas";
    case INTERACTION_SITES.CATALOG:
      return "catalog";
    case INTERACTION_SITES.CAMPAIGN_SETUP:
      return "campaign_qa";
    case INTERACTION_SITES.CANVAS_QA:
      return "canvas_qa";
    default:
      exhaustiveCheck(site);
      return "unknown";
  }
};
